<template>
  <v-layout row>
    <!--<v-flex xs12 sm6 offset-sm3> -->
      <v-card>
        <v-toolbar color="blue darken-3" dark >
          <v-toolbar-title>Serial Number - {{requestItemId}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn dark icon v-on="on" @click="save()">
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Save changes.</span>
          </v-tooltip>

          <!--
          <v-btn dark icon>
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn dark icon>
            <v-icon>view_module</v-icon>
          </v-btn>
          -->
        </v-toolbar>
        <v-container>
          <v-flex xs12 sm12 md12 lg12 xlg12 class="pa-0 ma-0">
            <v-switch
                class="pa-0 ma-0"
                style="margin-bottom: -12px !important;"
                v-model="bulkAdd"
                label="Bulk add serials."
                height="30"
                v-if="allowBulk"
            ></v-switch>
          </v-flex>
          <v-layout row wrap
                    v-if="bulkAdd"
                    style="min-width: 452px">
            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-subheader class="nopadding heading" >Serial Bulk Add</v-subheader>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-textarea
                box
                name="textSerialNumberInput"
                label="Serial Numbers (One Per Line)"
                v-model="bulkSerials"
              ></v-textarea>
            </v-flex>

          </v-layout>

          <v-layout row wrap
            v-if="!bulkAdd"
          >
            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-subheader class="nopadding heading" >Serial Number Approval</v-subheader>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-text-field
                  label="Serial Number"
                  v-model="serialNumber"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-text-field
                  label="Date Added"
                  v-model="dateAdded"
                  readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-select
                  :items="$store.state.ECOStatus"
                  label="ECO Status"
                  v-model="ecoStatus"
                  @change="ecoStatusChanged()"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-menu
                  v-model="menuEcoDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="ecoDate"
                      label="ECO Date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="ecoDate" @input="menuEcoDate = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-subheader class="nopadding heading" >Fulfillment</v-subheader>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-divider></v-divider>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-select
                  :items="$store.state.FulfillmentStatus"
                  label="Fulfillment Status"
                  v-model="fulfillmentStatus"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-menu
                  v-model="menuShipDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="shipDate"
                      label="Ship Date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="shipDate" @input="menuShipDate = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-text-field
                  label="Tracking"
                  v-model="tracking"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-subheader class="nopadding heading">Testing</v-subheader>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-divider></v-divider>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-select
                  :items="$store.state.TestingStatus"
                  label="Testing Status"
                  v-model="testingStatus"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-select
                  :items="$store.state.FailureCode"
                  label="Fail Code"
                  v-model="failureCode"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 xlg12>
              <v-text-field
                  label="RMA Number"
                  v-model="rmaNumber"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-text-field
                  label="RMA Tracking"
                  v-model="rmaTracking"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-select
                  :items="$store.state.RMAReceivedOptions"
                  label="RMA Received"
                  v-model="rmaReceived"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6 class="rightpad">
              <v-select
                  :items="$store.state.InvoiceStatus"
                  label="Invoice Status"
                  v-model="invoiceStatus"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6 xlg6>
              <v-text-field
                  label="Invoice Number"
                  v-model="invoiceNumber"
              ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>



      </v-card>
    <!--</v-flex>-->
    <v-snackbar
        v-model="snackbar"
        top
    >
      {{ snackbarText }}
      <v-btn
          color="light-green"
          flat
          @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  import moment from 'moment';

  export default {
    components: {
    },
    data() {
      return {
        bulkAdd: false,
        snackbar: false,
        snackbarText: '',
        requester: this.getUsername(),
        requestType: null,
        requestStatus: 'New',
        requestDate: moment().format('L'),

        bulkSerials: '',

        // START: Data object properties
        serialNumber: '',
        dateAdded: '',
        ecoStatus: '',
        ecoDate: '',
        fulfillmentStatus: '',
        shipDate: '',
        tracking: '',
        testingStatus: '',
        failureCode: '',
        rmaNumber: '',
        rmaTracking: '',
        rmaReceived: undefined,

        invoiceStatus: undefined,
        invoiceNumber: undefined,
        // END: Data object properties

        menuEcoDate: false,
        menuShipDate: false,

        itemName: '',
        max25chars: v => v.length <= 25 || 'Input too long!',
        validateNumber: v => !Number.isNaN(v),
        props: ['saveCallback'],
        headers: [
          {text: 'Item ID', align: 'center', value: 'itemId'},
          {text: 'Qty Requested', value: 'quantityRequested'},
          {text: 'Price', value: 'price'},
          {text: 'Actions'},
        ],
        items: []
      };
    },
    props: ['requestId', 'requestLineId', 'existingSerial', 'requestItemId', 'allowBulk'],
    watch: {
      existingSerial(data) {
        console.log('watched, existingSerial:', data);
        if (data) {
          this.serialNumber = data.serialNumber;
          this.dateAdded = data.dateAdded;
          this.ecoDate = data.ecoDate;
          this.ecoStatus = data.ecoStatus;
          this.fulfillmentStatus = data.fulfillmentStatus;
          this.shipDate = data.shipDate;
          this.tracking = data.tracking;
          this.testingStatus = data.testingStatus;
          this.failureCode = data.failureCode;

          this.rmaNumber = data.rmaNumber;
          this.rmaTracking = data.rmaTracking;
          this.rmaReceived = data.rmaReceived;

          this.existingRequestLineId = data.requestLineId;
          this.invoiceNumber = data.invoiceNumber;
          this.invoiceStatus = data.invoiceStatus;
        } else {
          this.serialNumber = undefined;
          this.dateAdded = undefined;
          this.property = undefined;
          this.ecoDate = undefined;
          this.fulfillmentStatus = undefined;
          this.shipDate = undefined;
          this.tracking = undefined;
          this.testingStatus = undefined;
          this.failureCode = undefined;
          this.rmaNumber = undefined;
          this.rmaTracking = undefined;
          this.rmaReceived = undefined;
          this.requestId = undefined;
          this.existingRequestLineId = undefined;
          this.bulkAdd = false;
          this.invoiceNumber = undefined;
          this.invoiceStatus = undefined;
        }
      },
      requestItemId(item) {
        console.log('watched, requestItemId changed:', item);
        this.itemName = item;
      }
    },
    methods: {
      ecoStatusChanged() {
        if (!this.ecoDate) this.ecoDate = this.formatDate(new Date());
      },
      save() {
        if (this.bulkAdd) {
          console.log('bulkAdd:', this.bulkSerials.split(/\r?\n/g));
          console.log('requestId:', this.requestId);
          console.log('requestLineId:', this.existingRequestLineId || this.requestLineId);

          this.$emit('save-bulk', {
            serials: this.bulkSerials.split(/\r?\n/g),
            dateAdded: this.formatDate(new Date()),
            requestId: this.requestId,
            requestLineId: this.existingRequestLineId || this.requestLineId,
            ecoStatus: 'Pending',
          });

          this.bulkAdd = false;
          this.bulkSerials = undefined;
          return;
        }

        console.log(`(this.ecoStatus === 'Pass' && !this.fulfillmentStatus)`, (this.ecoStatus === 'Pass' && !this.fulfillmentStatus));
        console.log('this.ecoStatus', this.ecoStatus);
        console.log('this.fulfillmentStatus', this.fulfillmentStatus);

        if (this.ecoStatus === 'Pass' && !this.fulfillmentStatus) {
          this.fulfillmentStatus = 'In Progress';
        }

        if (this.fulfillmentStatus === 'Shipped' && !this.testingStatus) {
          this.testingStatus = 'In Process';
        }

        console.log('this.testingStatus, this.invoiceStatus', {ts: this.testingStatus, is: this.invoiceStatus});
        if (this.testingStatus === 'Pass' && !this.invoiceStatus) {
          this.invoiceStatus = 'Pending';
        }

        if (!this.serialNumber) {
          this.snackbarText = 'No serial number, not saving.';
          this.snackbar = true;
          return;
        }

        this.snackbarText = 'Change have been saved.';
        this.snackbar = true;

        this.$emit('save', {
          serialNumber: this.serialNumber,
          dateAdded: this.dateAdded || this.formatDate(new Date()),
          ecoStatus: this.ecoStatus || 'Pending',
          ecoDate: this.ecoDate,
          fulfillmentStatus: this.fulfillmentStatus,
          shipDate: this.shipDate,
          tracking: this.tracking,
          testingStatus: this.testingStatus,
          failureCode: this.failureCode,
          rmaNumber: this.rmaNumber,
          rmaTracking: this.rmaTracking,
          rmaReceived: this.rmaReceived,
          requestId: this.requestId,
          requestLineId: this.existingRequestLineId || this.requestLineId,
          invoiceStatus: this.invoiceStatus,
          invoiceNumber: this.invoiceNumber,
        });

        this.serialNumber = undefined;
        this.dateAdded = undefined;
        this.property = undefined;
        this.ecoDate = undefined;
        this.fulfillmentStatus = undefined;
        this.shipDate = undefined;
        this.tracking = undefined;
        this.testingStatus = undefined;
        this.failureCode = undefined;
        this.rmaNumber = undefined;
        this.rmaTracking = undefined;
        this.rmaReceived = undefined;
        this.requestId = undefined;
        this.existingRequestLineId = undefined;
        this.bulkAdd = false;
      },
      getUsername() {
        if (this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          this.$store.state.user.attributes
        ) {
          return this.$store.state.user.attributes.name;
        }

        return 'unknown';
      },
      addRow() {
        this.items.push(
          {
            requestLineId: new Date().getTime(),
            itemId: 'item',
            quantityRequested: 0,
            price: 0.00,
            dateAdded: this.formatDate(new Date()),
            ecoStatus: 'Pending',
          }
        );
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      close () {
        // eslint-disable-next-line no-console
        console.log('Dialog closed');
      },
      deleteRow(item) {
        // eslint-disable-next-line no-console
        console.log('delete row:', item.requestLineId);
        const index = this.items.findIndex((i) => i.requestLineId === item.requestLineId);
        this.items.splice(index, 1);
        // eslint-disable-next-line no-console
        console.log('index:', index, 'items:', this.items);

      },
    },
    beforeUpdate() {
      console.log('$$$ this.existingSerial:', this.existingSerial);
    },
  }
</script>

<style>
  .nopadding {
   padding: 0px;
  }
  .heading {
    font-weight: bold;
  }
  .rightpad {
    padding-right: 8px;
  }
</style>
